import types from "./types";

export const save_broadcast_message = (payload) => {
  return {
		type: types.SAVE_BROADCAST_MESSAGE,
		payload: payload
	 }
}
